<template>
  <BasePageFull>
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'book-open']" size="2x" />
        <span class="text-2xl font-bold capitalize-first">
          {{ $t('navigation.note_book') }}
        </span>
      </div>
    </template>
    <template #cta>
      <BaseButton
        color="primary"
        icon="plus"
        :title="$t('button.add_new_f', { var: $t('global.note') })"
        @click="openForm"
      />
    </template>
    <template #body>
      <NoteFormDialog
        ref="eventModal"
        :isOpen="isOpen"
        :note_load_id="note_load_id"
        @backdropClicked="openForm"
        @close="closeDialogNote"
      />

      <BaseSimpleCard
        name="note"
        title=""
        classes="col-span-12"
        :borderedHeader="false"
      >
        <template #default>
          <!--#region filtres -->

          <div class="mb-5 flex space-x-5">
            <div class="flex flex-1 flex-col space-y-2">
              <BaseSelectMultiple
                v-if="metadata.note_types"
                :label="$t('attributes.type')"
                :placeholder="$t('attributes.type')"
                name="type_id"
                :value="null"
                :options="metadata.note_types"
                @setSelected.self="handleFilterTable"
              />

              <BaseSearchInput groupClass="mt-3" @typeInput="filterList" />
            </div>
            <div class="flex flex-1 flex-col space-y-2">
              <div class="flex flex-col">
                <label class="form-label mt-3 capitalize-first">
                  {{ $t('attributes.date') }}&nbsp;
                </label>
                <BaseDateRangeInput
                  :placeholder="$t('global.from_to')"
                  separator=" - "
                  :formatter="date_formatter"
                  v-model="emission_date"
                />
              </div>
              <div class="flex justify-end pt-3">
                <BaseButton
                  color="warning"
                  icon="sync"
                  :tooltip="$t('button.refresh')"
                  @click="fetchNotesIndex"
                />
              </div>
            </div>
          </div>
          <!--#endregion -->

          <!--#region table -->
          <div class="overflow-x-auto">
            <table class="table--sm table">
              <thead>
                <tr class="text-left">
                  <th
                    v-for="column in columns"
                    :key="column"
                    scope="col"
                    class="border-b-2 capitalize-first"
                  >
                    {{ $t(`attributes.${column}`) }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!filteredNotes.length">
                  <td
                    :colspan="columns.length"
                    class="text-center text-gray-500"
                  >
                    {{ $t('global.no_result_found') }}
                  </td>
                </tr>
                <tr
                  v-for="(note, idx) in filteredNotes"
                  :key="idx"
                  @click="openForm(note.id)"
                  class="cursor-pointer border-b hover:bg-gray-100 dark:hover:bg-gray-600"
                >
                  <td>{{ note.title }}</td>
                  <td v-html="note.description"></td>
                  <td>{{ note.work_title }}</td>
                  <td>{{ note.date }}</td>
                  <td>{{ note.type_string }}</td>
                  <td>{{ note.reporter_string }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--#endregion -->
        </template>
      </BaseSimpleCard>
    </template>
  </BasePageFull>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import moment from 'moment'
import NoteFormDialog from './NoteFormDialog'

export default {
  name: 'NoteIndex',
  components: {
    NoteFormDialog
  },
  data() {
    return {
      search: '',
      isOpen: false,
      note_load_id: null,
      searchTerms: '',
      filter: {},
      emission_date: '',
      date_formatter: {
        date: 'DD/MM/YYYY',
        month: 'MM'
      }
    }
  },
  computed: {
    ...mapGetters({
      noteList: 'note/getNoteIndex',
      note: 'note/getNote',
      metadata: 'note/getNoteMetadata'
    }),
    filteredNotes() {
      let temp_notes = this.noteList

      if (this.searchTerms.length >= 1) {
        temp_notes = temp_notes.filter((model) => {
          let search = this.searchTerms.length
            ? this.searchTerms.toLowerCase()
            : ''
          var values = this.filtrableColumns

          var flag = false
          values.forEach((val) => {
            if (
              model[val] &&
              model[val].toLowerCase().indexOf(search.toLowerCase()) > -1
            ) {
              flag = true
              return
            }
          })
          if (flag) return model
        })
      }
      if (this.filter.type_id) {
        temp_notes = temp_notes.filter((model) => {
          return this.filter.type_id.find((type) => {
            return type.id === model.type
          })
        })
      }
      if (this.emission_date !== '') {
        const [from, to] = this.emission_date.split(' - ')
        temp_notes = temp_notes.filter((model) => {
          const model_date = moment(model.date, 'DD/MM/YYYY').add(1, 'minutes')
          const search_start = moment(from, 'DD/MM/YYYY').startOf('day')
          const search_end = moment(to, 'DD/MM/YYYY').endOf('day')
          return model_date.isBetween(search_start, search_end)
        })
      }

      return temp_notes
    },
    columns() {
      return ['title', 'description', 'work', 'date', 'type', 'reporter']
    },
    filtrableColumns() {
      return ['title', 'description', 'work_title']
    }
  },
  methods: {
    ...mapActions({
      fetchNotesIndex: 'note/fetchNoteIndex',
      fetchNewNote: 'note/fetchNewNote'
    }),
    openForm(id) {
      if (id) {
        this.note_load_id = id
      }
      this.isOpen = !this.isOpen
    },
    closeDialogNote() {
      this.isOpen = !this.isOpen
    },
    filterList(terms) {
      this.searchTerms = terms
    },
    handleFilterTable({ attribute, value }) {
      let temp_filter = this.filter
      if (value.length === 0) {
        delete temp_filter[attribute]
        this.filter = temp_filter
      } else {
        this.filter = { ...this.filter, [attribute]: value }
      }
    }
  },
  beforeMount() {
    this.fetchNotesIndex()
  }
}
</script>
